// extracted by css-extract-rspack-plugin
export default {"cls1":"ReaderButtonRow-cls1_Jgh","cls2":"ReaderButtonRow-cls2_czT ReaderButtonRow-cls1_Jgh"};